const SERVICE_GLOBAL_ERROR = 'خطایی در درخواست رخ داده است، لطفا مجددا تلاش نمایید.';

export default SERVICE_GLOBAL_ERROR;
